import { PropertyPaymentBatchesContainer } from 'components/modules/Properties/Details/PaymentBatches';

export const PropertyPaymentBatches = () => <PropertyPaymentBatchesContainer />;
